import { Injectable } from '@angular/core';
import jwt_decode from 'jwt-decode';
import { UserService } from '../services/user.service';
import { TokenInterceptor } from '../token/token.interceptor';
import { RefreshFrameHelperService } from '../services/helpers/refresh-frame-helper.service';

@Injectable({
  providedIn: 'root'
})
export class TokenService {
  private refreshFrame: HTMLIFrameElement;
  private refreshIntervalId: number;

  decodedAccessToken: any;

  constructor(
    private userService: UserService,
    private tokenInterceptor: TokenInterceptor,
    private refreshFrameHelper: RefreshFrameHelperService) { }

  SetToken(token) {
    this.tokenInterceptor.token = token;
  }

  StartRefreshLoop(setGlobalUserDataCallback: (tokenData: any) => void) {
    console.log("Starting refresh loop");

    window.addEventListener("message", (event) => {
      console.log('received message', event);
      
      let accessToken = this.getAccessToken(event.data ? event.data : '');

      if (!accessToken) {
        return;
      }

      if (this.isAccessTokenChanged(accessToken)) {
        let updatedLoginTime = this.getDateString(new Date());
        
        console.log("updated login time", updatedLoginTime);
        localStorage.setItem("loginTime", updatedLoginTime);
      } else {
        console.debug("token is the same");
      }
      
      this.decodedAccessToken = this.getDecodedAccessToken(accessToken);

      console.log('decoded access token', this.decodedAccessToken, 'expiration dateTime stamp', this.decodedAccessToken.exp);

      this.SetToken(accessToken);
      setGlobalUserDataCallback({ token: accessToken });
      this.refreshFrameHelper.ClearRefreshFrameElement();
    });

    const checkRefreshTokenInterval = 60000;

    this.refreshIntervalId = window.setInterval(() => {
      this.RefreshToken();
    }, checkRefreshTokenInterval);
  }

  RefreshToken() {
    //console.log('decodedAccessToken', this.decodedAccessToken);

    let loginDate = this.parseDate(localStorage.getItem("loginTime"));
    
    if (!loginDate) {
      return;
    }

    if (this.decodedAccessToken && !this.isAccessTokenExpired(this.decodedAccessToken.exp * 1000)) {
      console.debug("skipping update");
      return;
    }

    // if (this.decodedAccessToken && this.isSessionExpired()) {
    //   console.log("Session was expired. Redirecting to Login Page.", this.refreshFrame, this.refreshFrame.src);

    //   let refreshUrl = this.refreshFrame.src;
    //   this.refreshFrameHelper.ClearRefreshFrameElement();

    //   location.href = refreshUrl;

    //   return;
    // }

    this.userService.GetCayuseRedirectURL().then(result => {
      document.domain = "cayuse.com";

      this.refreshFrame = this.refreshFrameHelper.InitRefreshFrameElement(this.refreshFrame);
      this.refreshFrame.setAttribute('src', result.data);

      console.log("Refresh frame", this.refreshFrame);
    });
  }

  GetRefreshIntervalId(): number {
    return this.refreshIntervalId;
  }

  GetNextTokenExpirationDateTime() {
    const oneHourTimeLength: number = 60 * 60 * 1000;
    let date = new Date();
    date.setTime(date.getTime() + oneHourTimeLength);
    
    return date;
  }

  private getAccessToken(hash: string): string {
    let pieces = [];

    if (typeof (hash) === 'string') {
      pieces = hash.split('&');
    }

    for (let kv of pieces) {
      let keyValue = kv.split("=");

      if (keyValue.length < 2) {
        continue;
      }

      if (keyValue[0] === "access_token") {
        return keyValue[1];
      }
    }
  }

  private isAccessTokenExpired(tokenExpirationTime: number): boolean {
    let currentTime = new Date().getTime();

    return currentTime >= tokenExpirationTime;
  }

  private isAccessTokenChanged(token): boolean {
    return token !== this.tokenInterceptor.token;
  }

  private getDecodedAccessToken(token: string): any {
    return jwt_decode(token);
  }

  // private isSessionExpired(): boolean {
    
  //   if (this.isAccessTokenExpired(this.decodedAccessToken.exp * 1000) && this.refreshFrame && this.refreshFrame.src) {
  //     return true;
  //   }

  //   return false;
  // }

  private getDateString(date: Date): string {
    return `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}-${date.getHours()}-${date.getMinutes()}`;
  }

  private parseDate(dateString: string): Date {
    let split = dateString.split('-');
    return new Date(parseInt(split[0]), parseInt(split[1]), parseInt(split[2]), parseInt(split[3]), parseInt(split[4]));
  }
}
